<template>
    <div class="page max640">

        <header class="pageHeader paddingH16" style="line-height: 46px;">
            <div class="borderLayout">
                <div class="middleRegion">
                    <div class="westRegion" style="width: 60px"></div>
                    <div class="centerRegion alignCenter font18r primaryTextColor bold">
                        {{title}}
                    </div>
                    <div class="eastRegion font14r alignRight" style="width: 60px">
                        <!--                            <router-link to="/search" class="icon searchIcon alignM" style="width:14px;height:15px;"></router-link>-->
                    </div>
                </div>
            </div>
        </header>

        <div class="body marginT8">
            <div class="">

                <!-- 广告图 -->
                <div class="generalPagePaddingH" style="margin-top: 12px;" data-notice="广告分类：发现页">
                    <bannerModule4 :itemCount="99" version="4" categoryKey="DISCOVER_PAGE" />
                </div>

<!--                <parkListModule title="火热招聘"/>-->

                <div class="paddingH8">
                    <latestContent/>
                </div>

                <div style="height: 8px; background: #F5F5F5;"></div>

                <div class="discoverModule">
                    <div class="">
                        <div class="moduleHeader paddingH16 paddingV12">
                            <div class="moduleTitle"></div>
                        </div>
                        <div class="moduleBody">

                            <div class="tabModule marginT12">
                                <div class="tabHeader paddingH16 paddingB16 autoOverflow hiddenScrollbar" >
                                    <div :style="'width:' + 60 * tabModule.panelItems.length + 'px'">
                                        <span class="tabItem grey20 bold" :class="{active : tabItem === tabModule.activePanelItem}"
                                              v-for="tabItem in tabModule.panelItems" :key="tabItem.id"
                                              @click="clickTabItem(tabItem)">
                                            {{tabItem.title}}
                                        </span>
                                    </div>
                                </div>

                                <div class="tabBody paddingT12 white_bg">

                                    <!-- 环创用的是图集组件 -->
                                    <atlasList      v-show="tabModule.activePanelItem && tabModule.activePanelItem.id === 'atlas'"/>
<!--                                    <datum          v-show="tabModule.activePanelItem && tabModule.activePanelItem.id === 'datum'"/>-->
                                    <poster         v-show="tabModule.activePanelItem && tabModule.activePanelItem.id === 'poster'"/>
                                    <courseware     v-show="tabModule.activePanelItem && tabModule.activePanelItem.id === 'courseware'"/>
                                    <recruit_poster v-show="tabModule.activePanelItem && tabModule.activePanelItem.id === 'recruit'"/>
                                    <listen         v-show="tabModule.activePanelItem && tabModule.activePanelItem.id === 'audioCourse'"/>

                                </div>

                            </div>

                        </div>
                    </div>
                </div>

            </div>
        </div>

        <bottomMenu ref="bottomMenu" activePath="/discover"></bottomMenu>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// config
import appConfig    from '@/appConfig';

// data
import externalApp      from '@/data/externalApp';

// api
import consoleApi       from '@/components/platformApi/consoleApi';

// modules
import bannerModule4    from '@/components/ad/bannerModule4';
import parkListModule   from '@comp/humanResources/parkListModule';
import atlasList        from '@comp/atlas/atlasList';
import datum            from '@comp/datum/datum';
import poster           from '@pages/discover/poster';
import courseware       from '@pages/discover/courseware';
import recruit_poster   from '@comp/humanResources/recruit_poster';
import listen           from '../learn_secondary/listen';
import bottomMenu       from '@comp/bottomMenu.vue';
import latestContent    from "./modules/latestContent";

// util
import appHelper        from '@/util/appHelper';
import deviceHelper     from '@/util/deviceHelper';
import browserHelper    from '@/util/browserHelper';
import routeHelper      from '@/util/routeHelper';

const config = {
    name : 'discoverDetail',
    title : '发现',
    description : appConfig.name + ' - ' + appConfig.desc
};

export default {
    name: config.name,
    extends : shixunPagePart,
    components : {
        bannerModule4, parkListModule,
        atlasList, datum, poster, courseware, recruit_poster, listen,
        bottomMenu, latestContent
    },
    data () {
        return {
            title : config.title,
            description : config.description,
            apiConfig : config.apiConfig,
            externalApp : externalApp,

            browserHelper : browserHelper,

            tabModule : {
                panelItems : [{
                    title : '环创',
                    id : 'atlas'
                },{
                    title : '资料',
                    id : 'datum'
                }, {
                    title : '商城',
                    id : 'shop'
                },
                // {
                //     title : '海报',
                //     id : 'poster'
                // },
                // {
                //     title : '听书',
                //     id : 'audioCourse'
                // },
                {
                    title : '资讯',
                    id : 'news'
                },
                // {
                //     title : '师圈',
                //     id : 'information'
                // },
                // {
                //     title : '课件',
                //     id : 'courseware'
                // },
                {
                    title : '招聘',
                    id : 'recruit'
                }],
                // type: object|null
                activePanelItem : null
            }
        }
    },
    methods : {
        clickTabItem(tabItem) {

            this.tabModule.activePanelItem = tabItem;
            if (tabItem.id === 'news')
            {
                appHelper.goToPage('articleIndex');
            }
            if (tabItem.id === 'information')
            {
                appHelper.goToPage('informationIndex');
            }
            if (tabItem.id === 'datum')
            {
                appHelper.goToPage('datumIndex');
            }
            if (tabItem.id === 'atlas')
            {
                appHelper.goToPage('atlasIndex');
            }
            if (tabItem.id === 'shop')
            {
                appHelper.goToPage('shopGoodsList');
            }

        },
        viewMenu(name) {
            appHelper.goToPage(name);
        },
        setTab(type) {

            for (let i=0; i<this.tabModule.panelItems.length; i++)
            {
                if (this.tabModule.panelItems[i].id === type)
                {
                    this.tabModule.activePanelItem = this.tabModule.panelItems[i];
                }
            }
        },
        goToArticlePage() {
            appHelper.goToPage('articleIndex');
        },
        goToRecruitApp() {
            appHelper.redirect(externalApp.rcWebApp.url);
        },
        onClickWeAppLink() {
            if (deviceHelper.isBrowser && !browserHelper.isWechat)
            {
                appHelper.showHint('只能在微信里面打开小程序');
            }
        },
    },
    mounted() {

        this.tabModule.activePanelItem = this.tabModule.panelItems[0];

        // type 参数显示对应的 tab 面板
        let type = routeHelper.getParam(this, 'type');
        if (type)
        {
            this.setTab(type);
        }
    }
}
</script>

<style lang="scss" scoped>

.page {
    background-color: white;
    background-image: linear-gradient(180deg, #FFF0DB, white);
    background-size: 100% 235px;
    background-repeat: no-repeat;
    background-attachment: fixed;
}

.searchIcon {
    width: 18px;
    height: 19px;
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAmCAYAAABDClKtAAADVklEQVRYhcWYT4jVVRTHb00DNgYiuRUXuhAdH9zz+d6hgSf8RKQhGC3ih2U7CSIIhEJdBEK0qFaKKBptBLFoIWYgLRKhiGgSUjcTiFhBQfindPUGG2dczHvTnTu/9+b9Zt6fA2fx3r3nnM895/7uP+dKSJ7nA977ncAHkr6RdBuoAbPAbP33FUlHzewVYLCM/1ICrAM+BO40ANpRM5uS9CmwuZMwQ8CRMiAt9DNg3YqAJA0Dv7YI8kDSz5IuRnoV+LOFzUNJu5YFZGZjZjZV5BQ4I2lkCftNko4CfzSBe9s593SZDO0pcDIl6USWZavKDtB7f7g+mNTngbYcmFklzZCZ/SbJl4WJpVqtrgV+KfgQ9rY0BNYAtxPDyeVkp0WMr9Kv08w2NTWQ9EmaoU4CRXF+TOJczrLsmUUdQwjrC+bQikrWTEZHR59N1ztJe4roTyRQx7oB1BBgHzATxbuxoEOWZauSyf2wG2UrALuWZOv/ykh6NcnSmW4D1eO+k0AdiomPJ40tF8ZOCjAdxf4hJv4uLl2vgOpQ16PYNefcU42G36MsXe0x1KW4SiGE9Y2GeD5d6THUuTi+937DIihJX/cTysxwzjlnZv/2sXyfNytffGb6q5dQki7HUPPrY0I7MzIy8nyvoIC/o9i34oYDSQrf6wWQmW1PPrKT843e+y3JZO/JvJJ0MYF6eUEH4Ke4hJJe6iYQc7ej/+KFc9HxpWD/u9lNKEnfJtU5uKhTnucD9ZtIvGZ80SWgQ8mxpQasKexsZi8k2ZqR9H4ngUIIe4FHSZZeX2oUBxOwaeBUJ4CAN1Mg4Fye5wNLGQ5KOp0YzgITK1m/zOy8pOnE57VKpbK63RENAV8WgNWAC+3CjY+PD5nZSeBBga9Z4D5l3hiAQeDjJs4eAzfM7Kyk/ZKGG+q9fw04Bkyw8ADXTO9577e0Deacc2b2YrIVrERrkvYD/yT/3w0hbC0FVqlUVgPvxqeJZehH1Wp1rXPzO8j9FEzScCkw5+ZuPSGEcUnniR7KWuglM3sjy7LnUl8hhK3AvaT/HWBbabCG5Hk+AGwMIYxJ2i3pLe/97hDCmJlVXBsvKvWnprspWN2+fwJsKwD7vq9Qzs299LDwGj/Zbybn3DzYBDAJ7HgCwHW6Z9xb1m4AAAAASUVORK5CYII=');
}
.menuRow {
    padding: 14px 16px;
    background: white;
    line-height: 24px;
    font-weight: bold;
    font-size: 15px;
}
.rightAngleBracketIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAh0lEQVRYhe2Wuw2DQBAFN3AJBO5jdvMLKQB34oAuSRAuxRKWsBMCB4gMHogd6eKZ0320ZklyNoAn0EVErZBXwHdeo7s3uwaUUm5AL42IiDvwyoiMyIiViEkdMfxFvIHqGgEL8g/wUMn3O/8jyDU3X/r2ryuXDyTz7nX/vZkZ0Lq7ZihNki34Aa/foFkSGOvFAAAAAElFTkSuQmCC');
}
.atlasIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADT0lEQVRoge2XMWjUUBjHMzgULNTBocMNDoIO4pAv4S753mnsqdTWocPRTXRQ0EkHoZsI2lnBoRZEBQULFtyqbV58goJDwYJFOjgcpWKHGxQ6KEj9OzRpX9JrL1dzbcX84S13+ZLfL9/37hLDyJMnT548efLswnie10FEVy3LmiaiJSLCNq+l8NpXPc/raAnetu1uIprZAeiN1oxt292t3PnZxAkWiEht81pISqTqhGma17SimmmapZbal2FM0ywRUS3iMU3zWpqiaa1gx+A1npLGM920gIh+RGPT6HuoYgGB+xxS1CFFHYF4holiIXPyONNitLHTHByNj0p+B1UsQHIdkpFYdaj2SYR7AkSENAdvLCDF8xD4PpS3H8rbhyl+DMlAIJ61hd7IVCC8+8rbt/qZ8vZHXciYW2fKBQzDMAz4PLYyLjyyOkKSH0Ey4PNYW+iNLAX+9U1sGKHESifqkFyHz2PthA+ZshPYiexKASivA764CZ8/Q/IvSJ6GdKsbMO0uASivE5LfNthLQMDrnnd2lQCU3Y2AZzXoXwjEQkLictsFoIoFvHaOQ7lHUsNPFAsIeG4NVizCF8IwDAO+uB2T0sYp418hrxMBP0m0fgaTzuFN4Sedw5C8GINP1ECKu3EJpzdTgfCPq/HsSl4HtFo3xVYMPuA5KOdgw2MlP9XOuQRfiEwEwtmdi5084DuJz2pQ8Vc/+EJA8lIcfuPXQyhvDySP69fpPUGf/koAr5yD62Z3iq2GYhogZHkgBu/zO/05ahOJDvj8Lqq7VLWwZYFUs6vsbkiuaXftPRSfD3/fQ3j3DZTX2RRgTaIzktiyQNj+xOw2fmxYERWaaGyNQ3l70sKvSax0t1WBH0QEt0j1xOzObja7axL8LQH/YCvwusSpY7RMRHBLtNy0QH+p//jQ0Wc3VfvxsnQAAd+DFC8w5V7YKniUi4NWX8Rzpoe+NC3or9g3ooKzJy28H3E+tDK7WebioNXnluh7xFPtt4abFo0OUVelTPPaXkBPmX4OnKbadq6eMv3UGSplmr9+7ujeVOa3rliHkhI7uSplmr91xTrUUvtGh6ir2m8N91Wsr+zQ7+2Gdku03Fexvlb7reHRIepqCT5Pnjx58vw3+QMWD7LsQbHwiwAAAABJRU5ErkJggg==');
}
.datumIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACKElEQVRoge2YMWgTURjHv6GDWzI4duwc777/dzl6UfOswaot4iItgthBcOhQ0Eo2CTo4ODjYJbpKFwcHhw4aC3bI4JAhs2Sok7gVBOlwDr2HR0Ev716SO/D94D8E7n3f97s7eJdH5HA4HA6Ho4R4nldl5pcAhgBiyxwopc7MbHhmXgBwOIHB07k3k+GVUnMA+roxMx8lv/dz5EDXqQcYxp8Wm2NnX53NJeD7fit11wa1Wm3e5oYw8xddb/B6MY4/NsbNcdxrPDNuCOChbuj7/rrN8EREt67XH+h6jzYCE4GT9KINo4bM3NENRUTZCnTbqFyM8Ct5jeKvu9Fu/CHq/DO9xos/EtH7QgWIiFaX8ErXvHlFuuOsSQmMjJpNQ+DJ/fq5enBSs9mQn902KllrSiVARLRyGZ913bVVbGVdXzqBzdtyR9e9thR8y7q+dAJERMtN+a5rt+/K5vMthH/Lj3dR+QTWVoLHOXfxUbIxni9UoNtG5UKE47yfI8zcKVSAiOjqJV6+0ZK9cSMie6USMEVElBMoEicw9QkzcAJTnzCDiQgAeJvshll5WjoBz/OqBjul2XfLLASIiAC8YeZRVkQku0ERAkViLABgOyVg/afeFhFZT72m25kLTh+rhGFodaxiQxiG8wAGeh7f91uZi04fbAE4Qv6DLZv0k956jr5Sam4s8ykdLdrkkJkXjB5fcri7g8kc7ubNkJl3PM+rGg3vcDgcjv+G39eyMawohvhIAAAAAElFTkSuQmCC');
}
.listenIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAC4ElEQVRoge2ZzWsTURTFX0URFN1IN4K7lNga67xzh37MbYuCIHRRRQRBF1rQoiCoCAr+AaIFcaELiyCCEUEooqg0mZe2ghuxYHGtGxEXih8I/aBWrgsnzTQmmtqZ9glz4CyGN+/d8yN33hsmSiVKlKhmtbS0bHAcpxvA/sXadd3d6XR63ZKF11rvBPAZgERlIhpJpVLrYw+fyWQ2AfhKRBKDc0qpulgBHMc5WiwI4BWAB/9qrfWXChDZWAG01mdCAGcXudZ4sI4AmAnWnSWii1HlrVQ0FgDXdQeC8AJgGkBfVJnLi8b1CzQDuBZqpUkAu6LKHS4aG4BSShHR/dD6E0SEaJKXisYKkEqlVgMYDdV4DyAVTXoVHwARZQFcDZwlom+hdnqpta63EeBFrWeE1vqyjQAXQi1U7YQu1hq0DkApVae17gHQW8VXihC2AvxRjuPssR5Acu2bxfBBGaNV5WNWA4jftVV8zorhKTEsYvh2+T1WAshQxzYp8J1Q8F8ueI+tBxDD16XAk/OCG56SPN+TZ7zRagDJc89vwQ1nxbQ2V5tjF4BpOyTGC8J745LzMn+bYzPA3VrmJACVVCuAPOmsl4J3XAz3S77jnBjv0n8DID7vFcOf5j20Pn8vXVsMIMPcLYZnynacMlsKICPbV4rPb0JBn4rPpyTPt8TnafsB/HYthmeDoO8k17x2bszwDfsBwoeV75l5YwU+Fhqr6dvP0gMMc1rMXKt8lHxrg1JKiagV4nuPQs/BeSsBlFJKfG+09ILGH8TwQzH8OhR+QvJdDRYDtDWKX7aFllrnh/jtJ2qttYznQFujGO+5mGDv91nE57fie70LqbXsrxIyzFvEePtkqHWHjNGahdZadoDFKgGoJAB9IYCC67r9cRnAYBHAcZybkQBorZuCj65x/ENTzbNEdCASAKWUAnCYiCaXKPwMgIHIwheltW5yHOcIgNNxmYhOAuiMPHyiRIns1E8gRB/8FUzJHAAAAABJRU5ErkJggg==');
}
.articleIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACOElEQVRoge2YMWgUQRSGB7SwsFFEYreFdrm7ef/bwN3NIqeNjYUQsBUhimCT1kpRC7FRBNHO0iIgaIrI3R5bpLVLJYIgVlYBiZzxAmOz8dZzsu7lZnJDmB/+Zot5/zfDvHmsEEFBQZUURdExADcBPCWiZ9MawBMiah1k+LfMrG0awE9mvuAcAMDyWOF92wCyRUQNpwDMvLJbkIheAFiewhuGk/gipYycAQB4t7vzRLQ45VqrhVPcKkB8aLVaJ21lHi/qBEBK+bAIwcxdIcQRS7H/KuoEgIgWAVxk5kHhJF7byl0s6gxACCGY+Rozb+cQOwAe20k+KuoUIP9+l5l3cohfRHRr+uSjxa0D5B3tM4CNggeF+zBoNBqXvAMgosoPIhF99A4AwHUA21UeOyLa9A5ACCHiOJ4novMmM/MVZv7uNUCZmPlMABhXGYDuqyXda98zWzW9BtBdFetU6T3dV5/8BsiakU7VsARi3WuAPxC9pGN01jnuPYBtBQCTDi2AzviU7re/lnaikYc6TS77BdBLkorh87bafuAXQNY5qlP1Uqcq+7+TFZ21znoF4EIBwKRDDaD7akmn6tXkTm7PHED3VHOiLjRuw7Q6i2FusE+AoX7/b1eawTC3MLfnMFfmbGHOVCtcYpMCwARyBfCm8K/mEYCrDn0DwI98w75ZAZBS3qn6N82mAaxaAajVaicArB9w+M04juetAAghRL1eP01E9wGsMXPXlQGsAXgupTxnLXxQUJC/+g1HbConusgN8gAAAABJRU5ErkJggg==');

}
.posterIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACwklEQVRoge2ZP2gUQRTGF4lFKoNoo1YWxpjszLzvu8vdnnfhAikUC0FjbROrFIKIlYVgY6eFpSBoaaXW1iksRIKIYhEQ/BONSTCJmjOuzV6crHvJIrObnOwHr9rZb99vZvbt7IznFSpUqFDXSEQuAXgB4E2WQfKZiIw5TV5rfYTkN5JhHgFgxvO8Xc4ASAKA/YBMwvJfJLnbGYBSah0AwEdjzLkMYhLASiYApVJJAPyKeuidM2NLvu8fJrmcOQCA7gPQWtsA750ZW8oUoFwuG5Jr0RTqPgBjjAHQBvjgzNhSpgAiorsegOTPdhl1ZmypANhMAJQFMBu/HtZqJjxePd8xGpXTYZP7diRAWA9OhI1quGWMVKe2DYCkT7KVCNCojacCqAfTOwKA5KcNAM1mT9ioToT16rWOMVK9GjZrQ9sG4Pt+RwCHz8h0LTRkTaHPzowtZQqglBoiuRqNwF8AW1ah5Mp01q5MeQLMbUg+bRVKfrGf5gJQLpcHOwKkrUKJpTV4mQuA1nodAMCXDQBpqlCKypT1UuIYgB9JAK5UAGymGMC8M2NLmQOQ7F4AAAP/DQDJhbT3KaUOARhI0zbrxdxRAN/TAARB0FsqlcZF5CGARQBLAJ4AOLNZUnkCLCa1if7abpB82/53iEWL5CuSF4Mg2LttAADWAYwxfcaYCySnSK7Ek462I1sJMHMAbmqtB3MBUEr12yOgtR4leYfkfEJyYdT2AclTSqkKgPvW/XYsA3gsIiezXk7388/2+mpSrwJYA/Ca5GUR2R/3EJEDJK8DmE2aXgBm7FF2CjA8PNzxfADAVwB3SY6m8QqCoJfkBMlpa68p7ul8MXcQwFKsx54DmDTG9P2rr4iMAXjU/srb74jneT3OADzP8wBciYb5NsmKS+/oBOgWyQUAoYjcc+mfm0juMcY0PZfHS4UKFdq5+g2t1G+mXydJTAAAAABJRU5ErkJggg==');

}
.coursewareIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAB5klEQVRoge2Zv4vUQBiGBxS1EgXtLLaId8K6yfe+n7CJJDCgVoK1iJ2FlYW9hX+InTaWYmFhoZZ2tjZqIdwhnKesP1YsxiYHIay3l8tk9tB54GlnvickIUyMiUQi/wej0ehYmqbnVZV9zbJsLejwInIVwDtV/a2qrq8k5yTvBhkewCWScx+DNwXwIcT8h1T1bePK/SI56+G3xlobg0+fpum6qv6oN/xKUgGc3q8icoVkuACSurMhgE1VPdVnPQAXggY0N6zdJPm5h1+atyOArbYkP5F8nCTJ0SECggngltcAki5UDEkH4I7XAAAbAK6JyI2hJPlqyICPvRdcgog8igFNYkBHYkCbfzrAFUXiyvz+X62mNw92QJU/dVXudrUokoMbUOYPlgTMnLWdPv7CBlh72JXT0pW5Xaidnum6X3yI28SAjoR+iO8tfQstdLrtbHFu9QFV/nx/Ablz1cXrqw+w+WVXFc9clb/o6ENn7YmVBwxBDGgTAzoSA9rEgI7EgDatgPceZtwV7wEicpbk93rRGckqy7K1oQTwxGuAMcaQfNM4s5yT3B5KVf3pPUBVSXIW8mS6Pki+7SXAGGNERAC8rM/4+/xi2pOq+noymZz0FrBDkiTH+/xi2qvj8fiI9+EjkcX8AYSaziooLcQzAAAAAElFTkSuQmCC');

}
.recruitIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAADpklEQVRoge2YP2gUWRzHB4mQA4twXJHCwsJC2BBmvt/f7M5sdtZ3GFBsvEI4C5FodUXAf8UdXJPiIIWiB3p4cEWEK2JnIWghRzhSWFgEES6FRYoUEVKkSHEe6r0rnJGfszuT2c3Mrhz7hVfN+/3e5/fevPf7vec4I4000kj/G7muO0HyMoAnJLdIWpJvSa6TXAJwctiMXWWMGRORH0nuxtB5bQ1AMGzmj6rVaodIrhQA1+0tgPlhszvGmHGSqym4dRGZF5EpY8y47/uTImIA3CX5d6rvd0MNQETuaCAAC8aYsaz+ruseIbmmV8L3fXeQzB8lIlPxBk1gfihiF/9yL5XdStWsXUXyXr8QJI/p4D3Pk6o48yC2FMBsr/YisqwmYLEKxkzF/3Iy+E4/PjzPO5f4EJEnZTPmSkSMCuBZPz48zxPl41XZjLlKBbDap48pdXptlM2Yq3gTJgFs9+njGxXA07IZiwDs7OcUIfmbmoSbVTDmSkR+VzO43Iut7/uTqazcqoozU6lNaD3PO1fEzhgzBuCpLu6qZs2UiDxIFWhzef3jcvuhDlxEzGBos4HWUwXaioicMcaMJ/0ajcZhktd18ot/vZ+GBp8o/p9fpoJI2j8k32V8G/zG7SYAR0kukXxf8C5gSb4meVmv0sDluu6EiNxOVaS9tk0A3w4cvl6vC4CNLkCvROT2rbrcW2827Itm3f7VrNsXM/U3MyJXASwD2E3bAViu1WqHBgIP4BQ7774r+jSx7eAXGwX2kzbTCBznwy0OwJX0hia56vv+ZKXwJFs6AQHYBXA+3c+2w7WOAI4H13Sf+AS7nwriWWUrMT09fZjkthpsg+SxDviT4Zc2Ct53BBCFD7v5BTCv91GvWb2wRERnzy0AR7v1s+3G6U74wNp28DrLdxyE3hNzpcIDOK8zbl7tYlvhYtcAosDaMOxYMTXGr2qMbdd1J0oLQGdbAD/n9bVR+GdmAK3wUpZdfNnfVEF8Xwq87/uzyunOXjNjo/CPjAD+te3wQp4tgDmdI0oJgJ/W7bmz7ziOY8PwC9sOHqfg39lW8+JetsaYMX1QlFLopRJWobrdkgdtFDyI4d/YqHm26Hh6wgAs9A0eO/tKn/l5r25pWcc5YKPwlv06PNHLmPq1guSj3qmV4sSVLOfzfTkrKH3Z535fK+KyYaAX7/ju0P+DAckb+6guq2w7hfZgRrU4bPjkN76zZwAissDOd/zPoW0O5RF4pJFGGilX/wHlXkPL+haAIwAAAABJRU5ErkJggg==');

}

.discoverModule {
    .moduleHeader {
        .moduleTitle {
            width: 89px;
            height: 31px;
            background-image: url('data:image/png;base64,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');
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }
    }
}

.tabModule {
    .tabHeader {
        .tabItem {
            position: relative;
            display: inline-block;
            margin-right: 24px;
            padding-bottom: 6px;
            font-size: 16px;
        }
        .tabItem:last-child {
            margin-right: 0;
        }
        .tabItem.active:before {
            content: '';
            position: absolute;
            z-index: 1;
            width: 14px;
            height: 2px;
            bottom: 0;
            left: 50%;
            margin-left: -7px;
            background: #FFA724;
            border-radius: 2px;
        }
    }
}
</style>
